import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "components/Button/Button";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Textbox } from "components/Textbox/Textbox";
import { UnitDictionary } from "pages/InventoryAndSales/Inventory/BaseDefinitionAndSetting/Unit/components/UnitDictionary";
import { useEffect, useRef, useState } from "react";
import { GUID_EMPTY, ICON_TYPE, INVENTORYANDSALES_URL } from "utils/constants";

import { DictionarySelectBox } from "components/DictionaryTypeSelect/DictionaryTypeSelect";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { trans, uuidv4 } from "utils/helpers";
import { getSellectableWarehouseItemDetail } from "../../SellectableWarehouseItem/api";
import { SellectableWarehouseItem } from "../../SellectableWarehouseItem/SellectableWarehouseItem";
import { ItemStockList } from "../../ItemStockList";

import { Toast } from "components/ToastShow/ToastAlert";
import { MessageType } from "types/enum";
import { Loading } from "components/Loading/loading";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { PriceInput } from "components/PriceInput/PriceInput";

interface SalesInvoiceFormProps {
  onHide: () => void;
  warehouseIODetail?: any;
  mode: any;
  warehouseId: any;
  selectedObj?: any;
  WarehouseDetailId?: any;
  WarehouseDetail?: any;
  WarehouseDetailsCount?: any;
  jobId?: any;
  constraint?: any;
  handleSubmitData?: any;
  reload?: boolean;
  flag?: any;
  initialStock?: number;
}

export const InventoryRemittanceDetailForm = ({
  mode,
  onHide,
  warehouseIODetail,
  warehouseId,
  selectedObj,
  WarehouseDetailId,
  WarehouseDetail,
  WarehouseDetailsCount,
  jobId,
  constraint,
  handleSubmitData,
  reload,
  flag,
  initialStock,
}: SalesInvoiceFormProps) => {
  const [showTree, setShowTree] = useState<any>();
  const [userChanges, setUserChanges] = useState({});
  const [loading, setLoading] = useState<any>(true);

  const [itemData, setItemData] = useState<any>();
  const [dictionaryNameUnit, setDictionaryNameUnit] = useState<any>({});
  const [detailWarehouseData, setDetailWarehouseData] = useState<any>({
    QtyOut2: 0,
    QtyOut1: 0,
    ItemValue: 0,
    ItemValueOut: 0,
    WageCost: 0,
                              UnitPrice:0,

  });
  const [warehouseData, setWarehouseData] = useState<any>({
    WarehouseId: warehouseId,
    WarehouseDetailId,
  });
  const [resetForm, setResetForm] = useState(false);
  const [itemStokList, setItemStokList] = useState<any>();
  const [itemSearch, setItemSearch] = useState<any>("");
  const itemCodeHandeler = (obj) => {
    setLoading(false);
    setItemData({
      Code: obj.ItemCode,
      Id: obj.Id,
      ItemDescription: obj.ItemDescription,
      TechnicalCode: obj.ItemTechnicalCode,
      ItemStockList: obj.ItemStockList,
      HasProductTracking: obj.HasProductTracking,
      HasExpireDate: obj.HasExpireDate,
    });
    setDetailWarehouseData({
      ...obj,
      UnitOut1Id: obj.MainUnitId,
      UnitOut2Id: obj.StatisticalUnitId,
      UnitOut2: obj.Unit2,
      UnitOut1: obj.Unit1,
      QtyOut1: obj.QtyMainUnit,
      QtyOut2: obj.QtyStatisticalUnit,
      ItemValue: 0,
      ItemValueOut: 0,
      WageCost: 0,
      PartyNo: null,
      ExpireDate: null,
                              UnitPrice:0,

    });
    setResetForm(true);
    setDictionaryNameUnit({ UnitOut2: obj.Unit2, UnitOut1: obj.Unit1 });
    setShowTree(false);
    setLoading(true);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (
      ((itemData?.HasProductTracking || itemData?.HasExpireDate) &&
        itemData?.ItemStockList?.length > 0 &&
        +event.target.QtyOut1?.value > itemStokList?.Stock) ||
      (+event.target.QtyOut1?.value > itemStokList?.Stock &&
        constraint?.ControlQtyWarehouseIO)
    ) {
      event.target.elements.QtyOut1.setCustomValidity(
        trans("Msg_ItemNotEnoughInStock")
      );
      event.target.elements.QtyOut1.reportValidity();
    } else {
      let data = {
        Id: mode != "create" ? selectedObj?.Id : uuidv4(),
        ItemId: itemData?.Id,
        SourceId:
          itemData?.Id == selectedObj?.ItemId
            ? selectedObj?.SourceId != GUID_EMPTY && selectedObj?.SourceId
              ? selectedObj?.SourceId
              : null
            : null,
        SourceData:
          itemData?.Id == selectedObj?.ItemId
            ? selectedObj?.SourceData
              ? selectedObj?.SourceData
              : null
            : null,
        ItemCode: itemData?.Code,
        Item: itemData?.ItemDescription,
        ItemTechnicalCode: itemData?.ItemTechnicalCode,
        HasProductTracking: itemData?.HasProductTracking,
        WarehouseDetail: warehouseData?.WarehouseDetail,
        WarehouseDetailId: warehouseData?.WarehouseDetailId,
        HasExpireDate: itemData?.HasExpireDate,
        ExpireDate:
          itemData?.HasExpireDate || itemStokList?.ExpireDate
            ? itemStokList?.ExpireDate
            : null,
        PartyNo:
          itemData?.HasProductTracking || itemStokList?.PartyNo
            ? itemStokList?.PartyNo
            : null,
        UnitOut1Id: event.target.UnitOut1Id?.value,
        UnitOut1: dictionaryNameUnit.UnitOut1,
        UnitOut2Id: event.target.UnitOut2Id?.value,
        UnitOut2: dictionaryNameUnit.UnitOut2,
        QtyOut1: +event.target.QtyOut1?.value,
        QtyOut2: +event.target.QtyOut2?.value,
        UnitPrice:+(event.target.UnitPrice?.value?.replaceAll(',','')),
        ItemValue: event.target.ItemValue?.value
          ? +(event.target.ItemValue?.value?.replaceAll(',',''))
          : 0,
        ItemValueOut: event.target.ItemValueOut?.value
          ? +(event.target.ItemValueOut?.value?.replaceAll(',',''))
          : 0,
        WageCost: event.target.WageCost?.value
          ? +(event.target.WageCost?.value?.replaceAll(',',''))
          : 0,
        Description: event.target.Description?.value,
        DescriptionEN: event.target.DescriptionEN?.value,
        QCNo: event.target.QCNo?.value,
        // QtySource: 0,
        // DeliveryCost: 0,
        OtherCost: 0,
        OverloadCost: 0,
        Calculated: event.target.Calculated?.checked,
        CalculatedBySystem: event.target.CalculatedBySystem?.checked,
        // CalculatedByAlteration: event.target.CalculatedByAlteration?.checked,
        ManualRegistered: event.target.ManualRegistered?.checked,
        // UnitIn1Id: event.target.UnitIn1Id?.value,
        // UnitIn1:dictionaryNameUnit.UnitIn1,
        // UnitIn2Id: event.target.UnitIn2Id?.value,
        // UnitIn2:dictionaryNameUnit.UnitIn2,
        // Calculated: event.target.Calculated?.checked,
        // CalculatedBySystem: event.target.CalculatedBySystem?.checked,
        // CalculatedByAlteration: event.target.CalculatedByAlteration?.checked,
        // ManualRegistered: event.target.ManualRegistered?.checked,
        // QtyIn1: +event.target.QtyIn1?.value,
        // QtyIn2: +event.target.QtyIn2?.value,
        // ItemValueIn: +event.target.ItemValueIn?.value,


        UnitIn1Id: null,
        UnitIn2Id: null,
        ItemEN: null,

        WarehouseDetailEN: null,
        UnitIn1EN: null,
        UnitIn2EN: null,

        HasSerial: false,

        IsSerialObligatory: false,
        ReturnableQty: null,

        QtyIn1: null,
        UnitIn1: null,
        QtyIn2: null,
        UnitIn2: null,
        ItemValueIn: null,
      };

      if (
        ((itemData?.HasProductTracking || itemData?.HasExpireDate) &&
          itemData?.ItemStockList?.length > 0 &&
          +event.target.QtyOut1?.value > itemStokList?.Stock) ||
        (+event.target.QtyOut1?.value > itemStokList?.Stock &&
          constraint?.ControlQtyWarehouseIO)
      ) {
        Toast(trans("Msg_InvalidItemStock"), MessageType.error);
      } else {
        handleSubmitData?.(data);
        onHide && onHide();
      }
    }
  };

  const getItemDetailAsync = async (
    id = null,
    e = null,
    useSelectedObj = false
  ) => {
    setLoading(false);
    try {
      let res;
      if (mode != "view") {
        res = await getSellectableWarehouseItemDetail(
          id,
          warehouseData?.WarehouseId,
          warehouseData?.WarehouseDetailId,
          false,
          e,
          jobId
        );
        setItemData({
          Code: res.Data.ItemCode,
          Id: res.Data.Id,
          ItemDescription: res.Data.ItemDescription,
          TechnicalCode: res.Data.ItemTechnicalCode,
          ItemStockList: res.Data.ItemStockList,
          HasProductTracking: res.Data.HasProductTracking,
          HasExpireDate: res.Data.HasExpireDate,
        });
      } else {
        setItemData({
          Code: selectedObj?.ItemCode,
          Id: selectedObj?.ItemId,
          ItemDescription: selectedObj?.Item,
          TechnicalCode: selectedObj?.ItemTechnicalCode,

          HasProductTracking: selectedObj?.HasProductTracking,
          HasExpireDate: selectedObj?.HasExpireDate,
        });
      }

      if (useSelectedObj) {
        setDetailWarehouseData((prev) => {
          return {
            ...prev,
            ...selectedObj,
            ItemDescription: selectedObj?.Item,
          };
        });
      } else {
        //when onblur event is run, we should set DetailWarehouseData
        setDetailWarehouseData({
          ...res.Data,
          UnitOut1Id: res.Data.MainUnitId,
          UnitOut2Id: res.Data.StatisticalUnitId,
          UnitOut2: res.Data.Unit2,
          UnitOut1: res.Data.Unit1,
          QtyOut1: res.Data.QtyMainUnit,
          QtyOut2: res.Data.QtyStatisticalUnit,
          ItemValue: 0,
          ItemValueOut: 0,
          WageCost: 0,
          PartyNo: null,
          ExpireDate: null,
                              UnitPrice:0,

        });
        setDictionaryNameUnit({
          UnitOut2: res.Data.Unit2,
          UnitOut1: res.Data.Unit1,
        });
      }
    } catch (error) {
      setShowTree(true);
      setItemSearch(e);
    }
    setLoading(true);
  };

  const updateQuantity = async (newQty, QtyInChange) => {
    setDetailWarehouseData({
      ...detailWarehouseData,
      QtyOut1:
        QtyInChange == "QtyOut1"
          ? newQty
          : newQty / detailWarehouseData.ConversionRatio,
      QtyOut2:
        QtyInChange == "QtyOut2"
          ? newQty
          : newQty * detailWarehouseData.ConversionRatio,
                 ItemValueOut:
                            detailWarehouseData?.WageCost + (detailWarehouseData?.UnitPrice * +(QtyInChange == "QtyOut1"
          ? newQty
          : newQty / detailWarehouseData.ConversionRatio)),
    });
  };

  useEffect(() => {
    //(!selectedObj?.QtyIn1 && !selectedObj?.QtyIn2)این شرط برای وقتی هست که سلکت ابجکت رسید هست و وقتی تغییر میدیم روی حواله باید فرم خالی بشه اگر این شرط نباشه فرم خالی نمیشه و با سلکت ابجکت پر میشه یعنی با رسید پر میشه و اشتباهه

    if (mode != "create" && !selectedObj?.QtyIn1 && !selectedObj?.QtyIn2) {
      getItemDetailAsync(selectedObj?.ItemId, null, true); //have condition on itemStock so we need it in edit an view mode -- in edit,view mode we need itemStockList for showing itemStokListComponent and we have to request to access to itemStockList
    }
  }, []);
  useEffect(() => {
    if (flag) {
      //use flag for providing initial render,it just render when increaseOrDecrease are changed// as soon as first render, it hasn't run useEffect
      setDetailWarehouseData({
        QtyIn2: 0,
        QtyIn1: 0,
        ItemValue: 0,
        ItemValueIn: 0,
        WageCost: 0,
                              UnitPrice:0,

        // DeliveryCost:0
      });
      setItemData(null);
    }
  }, [reload]);

  return (
    <>
      {loading ? (
        <div style={{ flexDirection: "row" }}>
          {showTree && (
            <ModalForm
              mode={mode}
              title="ItemTree"
              onHide={() => setShowTree(false)}
              show={showTree}
            >
              <SellectableWarehouseItem
                onHide={() => {
                  setShowTree(false);
                }}
                fetchItem={true}
                itemCodeHandeler={itemCodeHandeler}
                warehouseId={warehouseData?.WarehouseId}
                warehouseDetailId={warehouseData?.WarehouseDetailId}
                searchString={itemSearch}
                forItemInput={false}
                jobId={jobId}
              />
            </ModalForm>
          )}
          <div style={{ flexWrap: "nowrap" }} className="card-body row">
            <form action="" onSubmit={handleSubmit}>
              <div className="row">
                {((warehouseData?.WarehouseDetailId &&
                  warehouseData?.WarehouseDetailId != GUID_EMPTY) ||
                  (mode == "create" &&
                    !jobId &&
                    WarehouseDetailsCount > 0)) && (
                  <div className="col-lg-3">
                    <div className="">
                      <DictionarySelectBox
                        name="WarehouseDetail"
                        label="WarehouseDetail"
                        params={{ warehouseId: warehouseId }}
                        onChange={(e, obj) => {
                          setWarehouseData((prev) => {
                            return {
                              ...prev,
                              WarehouseDetailId: e,
                              WarehouseDetail: obj?.Name,
                            };
                          });
                          if (e != warehouseData.WarehouseDetailId) {
                            setDetailWarehouseData({
                              QtyOut2: 0,
                              QtyOut1: 0,
                              ItemValue: 0,
                              ItemValueOut: 0,
                              WageCost: 0,
                              UnitPrice:0,
                            });
                            setItemData({});
                          }
                        }}
                        baseUrl={INVENTORYANDSALES_URL}
                        endPoint={
                          ENDPOINTSINVENTORYANDSALES.Inventory
                            .BaseInformationApi.WarehouseDetail.dictionary
                        }
                        value={warehouseData?.WarehouseDetailId}
                        resetForm={resetForm}
                        mode={mode}
                      />
                    </div>
                  </div>
                )}
                <div
                  className="col-lg-3 col-sm-12"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "row",
                  }}
                >
                  <Textbox
                    required
                    onChange={(e) => {
                      if (e?.target.value === null || e?.target.value === "") {
                        setDetailWarehouseData({});
                        setItemData({});
                        setItemSearch("");
                      } else {
                        if (
                          // e.target.value != itemData?.Code &&
                          e.target.value.length > 2
                        )
                          if (isNaN(e.target.value)) {
                            setShowTree(true);
                          }
                        setItemSearch(e.target.value);
                      }
                    }}
                    onBlurHandler={(e) => {
                      if (e && e != itemData?.Code && !showTree) {
                        getItemDetailAsync(null, e);
                      }
                    }}
                    textboxName={"itemCode"}
                    textboxType="text"
                    labelText={"itemCode"}
                    mode={mode}
                    value={itemData?.Code}
                    defaultValue={itemData?.Code}
                  />
                  {mode != "view" && (
                    <div style={{ marginTop: "4px", width: "10%" }}>
                      <Button
                        Icon={true}
                        value={
                          <button
                            onClick={(e) => setShowTree(true)}
                            type="button"
                            className="checkButton d-flex align-items-center justify-content-center"
                          >
                            {" "}
                            <FontAwesomeIcon
                              icon={[ICON_TYPE, "diagram-project"]}
                              size="1x"
                            />
                          </button>
                        }
                        btnType="primary"
                        onClick={(e) => setShowTree(true)}
                      />
                    </div>
                  )}
                </div>
                {/* <div className="col-lg-3">
              <UnitDictionary
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                value={detailWarehouseData?.UnitIn1Id}
                label="UnitIn1Id"
                name="UnitIn1Id"
                required={false}
                // resetForm={resetForm}
                setUnitDictionary={(e) => {
                  setDictionaryName({ ...dictionaryName, UnitIn1: e.Value });
                }}
              />
            </div> */}
                {/* <div className="col-lg-3">
              <UnitDictionary
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                value={detailWarehouseData?.UnitIn2Id}
                label="UnitIn2Id"
                name="UnitIn2Id"
                required={false}
                // resetForm={resetForm}
                setUnitDictionary={(e) => {
                  setDictionaryName({ ...dictionaryName, UnitIn2: e.Value });
                }}
              />
            </div> */}

                {itemData && itemData?.ItemDescription && (
                  <div className="col-lg-4">
                    <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      withChangeDir={true}
                      textboxName="ItemDescription"
                      textboxType="text"
                      labelText="itemDescription"
                      value={itemData?.ItemDescription}
                      defaultValue={itemData?.ItemDescription}
                      resetForm={resetForm}
                      mode={"view"}
                      required={false}
                    />
                  </div>
                )}
                <div className="col-lg-3">
                  <UnitDictionary
                    returnObj
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    value={detailWarehouseData?.UnitOut1Id}
                    label="UnitOut1"
                    name="UnitOut1Id"
                    required={true}
                    resetForm={resetForm}
                    setUnitDictionary={(e) => {
                      setDictionaryNameUnit({
                        ...dictionaryNameUnit,
                        UnitOut1: e?.Value,
                      });
                    }}
                    mode={"view"}
                  />
                </div>
                <div className="col-lg-3">
                  <Textbox
                    required
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxName="QtyOut1"
                    textboxType="text"
                    labelText="QtyOut1"
                    customValidation={(e) =>
                      +e <= 0 && {
                        invalid: true,
                        message: "Msg_ValueCannotBeZero",
                      }
                    }
                    max={
                      (itemData?.HasProductTracking ||
                        itemData?.HasExpireDate) &&
                      itemData?.ItemStockList?.length > 0
                        ? itemStokList?.Stock
                        : undefined
                    }
                    value={
                      detailWarehouseData?.QtyOut1
                        ? detailWarehouseData?.QtyOut1
                        : null
                    }
                    defaultValue={
                      detailWarehouseData?.QtyOut1
                        ? detailWarehouseData?.QtyOut1 + ""
                        : null
                    }
                    mode={mode}
                    onChange={(e) => {
                      updateQuantity(+e.target.value, "QtyOut1");
                    }}
                  />
                </div>

                {/* <div className="col-lg-3">
              <Textbox
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                textboxName="QtyIn1"
                textboxType="text"
                labelText="QtyIn1"
                value={detailWarehouseData?.QtyIn1}
                defaultValue={detailWarehouseData?.QtyIn1}
              />
            </div> */}
                {/* <div className="col-lg-3">
              <Textbox
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                textboxName="QtyIn2"
                textboxType="text"
                labelText="QtyIn2"
                value={detailWarehouseData?.QtyIn2}
                defaultValue={detailWarehouseData?.QtyIn2}
                mode={mode}

              />
            </div> */}
                {detailWarehouseData?.UnitOut2Id && (
                  <>
                    <div className="col-lg-3">
                      <UnitDictionary
                        returnObj
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        value={detailWarehouseData?.UnitOut2Id}
                        label="UnitOut2"
                        name="UnitOut2Id"
                        required={true}
                        resetForm={resetForm}
                        setUnitDictionary={(e) => {
                          setDictionaryNameUnit({
                            ...dictionaryNameUnit,
                            UnitOut2: e?.Value,
                          });
                        }}
                        mode={"view"}
                      />
                    </div>
                    <div className="col-lg-3">
                      <Textbox
                        required
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        textboxName="QtyOut2"
                        textboxType="text"
                        customValidation={(e) =>
                          +e <= 0 && {
                            invalid: true,
                            message: "Msg_ValueCannotBeZero",
                          }
                        }
                        labelText="QtyOut2"
                        value={
                          detailWarehouseData?.QtyOut2
                            ? detailWarehouseData?.QtyOut2
                            : null
                        }
                        defaultValue={
                          detailWarehouseData?.QtyOut2
                            ? detailWarehouseData?.QtyOut2 + ""
                            : null
                        }
                        mode={mode}
                        onChange={(e) => {
                          updateQuantity(+e.target.value, "QtyOut2");
                        }}
                      />
                    </div>
                  </>
                )}
                {/* <div className="col-lg-3">
              <Textbox
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                textboxName="QtySource"
                textboxType="text"
                labelText="QtySource"
                value={detailWarehouseData?.QtySource}
                defaultValue={detailWarehouseData?.QtySource}
              />
            </div> */}
             

                       <div className="col-lg-3">
                  <PriceInput
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    name="UnitPrice"
                  
                    label="UnitPrice"
                    onChange={(e) => {
                      setDetailWarehouseData({
                        ...detailWarehouseData,
                        UnitPrice: +(e.target.value?.replaceAll(',','')),
                        ItemValueOut:
                          (+(e.target.value?.replaceAll(',','')) * +detailWarehouseData.QtyOut1 ) +
                          +detailWarehouseData.WageCost 
                         ,
                      });
                    }}
                    value={detailWarehouseData?.UnitPrice}
                    defaultValue={detailWarehouseData?.UnitPrice}
                    mode={mode}
                  />
                </div>
                <div className="col-lg-3">
                  <PriceInput
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    name="ItemValue"
                  
                    label="ItemValue"
                   
                    value={detailWarehouseData?.UnitPrice * detailWarehouseData?.QtyOut1}
                    defaultValue={detailWarehouseData?.UnitPrice * detailWarehouseData?.QtyOut1}
                    mode={"view"}
                  />
                </div>




                {/* <div className="col-lg-3">
              <Textbox
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                textboxName="ItemValueIn"
                textboxType="text"
                labelText="ItemValueIn"
                mode={"view"}
                value={detailWarehouseData?.ItemValueIn ?? totalValueIn}
                defaultValue={detailWarehouseData?.ItemValueIn ?? totalValueIn + ""}
              />
            </div> */}

                {/* <div className="col-lg-3">
              <Textbox
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                textboxName="DeliveryCost"
                textboxType="text"
                labelText="DeliveryCost"
                onChange={(e) => {
                  setTotalValueIn(totalValueIn + +e.target.value);
                }}
                value={detailWarehouseData?.DeliveryCost}
                defaultValue={detailWarehouseData?.DeliveryCost}
              />
            </div> */}
                {/* <div className="col-lg-3">
              <Textbox
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                textboxName="OtherCost"
                textboxType="text"
                labelText="OtherCost"
                onChange={(e) => {
                  setTotalValueIn(totalValueIn + +e.target.value);
                }}
                value={detailWarehouseData?.OtherCost}
                defaultValue={detailWarehouseData?.OtherCost}
              />
            </div> */}
                {/* <div className="col-lg-3">
              <Textbox
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                textboxName="OverloadCost"
                textboxType="text"
                labelText="OverloadCost"
                onChange={(e) => {
                  setTotalValueIn(totalValueIn + +e.target.value);
                }}
                value={detailWarehouseData?.OverloadCost}
                defaultValue={detailWarehouseData?.OverloadCost}
              />
            </div> */}
                            <div className="col-lg-3">
                  <PriceInput
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    name="WageCost"
                   
                    label="WageCost"
                    onChange={(e) => {
                      setDetailWarehouseData((prev) => {
                        return {
                          ...prev,
                          WageCost: +(e.target.value?.replaceAll(',','')),
                          ItemValueOut:
                            +(e.target.value?.replaceAll(',','')) + (detailWarehouseData?.UnitPrice * detailWarehouseData?.QtyOut1),
                        };
                      });
                    }}
                    value={detailWarehouseData?.WageCost}
                    defaultValue={detailWarehouseData?.WageCost}
                    mode={mode}
                  />
                </div>
                <div className="col-lg-3">
                  <PriceInput
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    name="ItemValueOut"
                  
                    label="ItemValueOut"
                    value={detailWarehouseData?.ItemValueOut+""}
                    defaultValue={detailWarehouseData?.ItemValueOut+""}
                    mode={"view"}
                    // onChange={(e) =>
                    //   setDetailWarehouseData((prev) => {
                    //     return {
                    //       ...prev,
                    //       ItemValue: +e.target.value,
                    //       ItemValueOut: +e.target.value,
                    //     };
                    //   })
                    // }
                  />
                </div>

                <div className="col-lg-3">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxName="QCNo"
                    textboxType="text"
                    labelText="QCNo"
                    value={detailWarehouseData?.QCNol}
                    defaultValue={detailWarehouseData?.QCNo}
                    mode={mode}
                  />
                </div>
                {(((itemData?.HasProductTracking || itemData?.HasExpireDate) &&
                  itemData?.ItemStockList?.length > 0 &&
                  loading) ||
                  (mode != "create" &&
                    detailWarehouseData?.ExpireDate &&
                    detailWarehouseData?.PartyNo)) && (
                  <div className="col-lg-7">
                    <ItemStockList
                      sendDataCallBack={(obj) => setItemStokList(obj)}
                      defaultValue={detailWarehouseData}
                      data={itemData}
                      mode={mode}
                      initialStock={initialStock}
                      useCalculateItemStock={true}
                    />
                  </div>
                )}
                <div className="col-lg-6">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxName="Description"
                    textboxType="textarea"
                    labelText="Description"
                    value={detailWarehouseData?.Description}
                    defaultValue={detailWarehouseData?.Description}
                    mode={mode}
                  />
                </div>
                <div className="col-lg-6">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxName="DescriptionEN"
                    textboxType="textarea"
                    labelText="DescriptionEN"
                    value={detailWarehouseData?.DescriptionEN}
                    defaultValue={detailWarehouseData?.DescriptionEN}
                    mode={mode}
                  />
                </div>
                <div className="w-100"></div>
                {/* <div className="col-12 col-lg-3">
              <CheckableButton
                defaultChecked={detailWarehouseData?.Calculated}
                defaultValue={detailWarehouseData?.Calculated}
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                labelText={"Calculated"}
                inputName={"Calculated"}
                type="checkbox"
                mode={mode}
              />
            </div>
            <div className="col-12 col-lg-3">
              <CheckableButton
                defaultChecked={detailWarehouseData?.CalculatedBySystem}
                defaultValue={detailWarehouseData?.CalculatedBySystem}
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                labelText={"CalculatedBySystem"}
                inputName={"CalculatedBySystem"}
                type="checkbox"
                mode={mode}
              />
            </div> */}
                {/* <div className="col-12 col-lg-3">
              <CheckableButton
                defaultChecked={detailWarehouseData?.CalculatedByAlteration}
                defaultValue={detailWarehouseData?.CalculatedByAlteration}
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                labelText={"CalculatedByAlteration"}
                inputName={"CalculatedByAlteration"}
                type="checkbox"
                mode={mode}
              />
            </div> */}
                {/* <div className="col-12 col-lg-3">
              <CheckableButton
                defaultChecked={detailWarehouseData?.ManualRegistered}
                defaultValue={detailWarehouseData?.ManualRegistered}
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                labelText={"ManualRegistered"}
                inputName={"ManualRegistered"}
                type="checkbox"
                mode={mode}
              />
            </div> */}
                <div className="w-100"></div>
                <div className="col-12 col-lg-3">
                  <CheckableButton
                    defaultChecked={detailWarehouseData?.Calculated}
                    defaultValue={detailWarehouseData?.Calculated}
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    labelText={"Calculated"}
                    inputName={"Calculated"}
                    type="checkbox"
                    mode={mode}
                  />
                </div>
                <div className="col-12 col-lg-3">
                  <CheckableButton
                    defaultChecked={detailWarehouseData?.CalculatedBySystem}
                    defaultValue={detailWarehouseData?.CalculatedBySystem}
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    labelText={"CalculatedBySystem"}
                    inputName={"CalculatedBySystem"}
                    type="checkbox"
                    mode={mode}
                  />
                </div>
                <div className="col-12 col-lg-3">
                  <CheckableButton
                    defaultChecked={detailWarehouseData?.ManualRegistered}
                    defaultValue={detailWarehouseData?.ManualRegistered}
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    labelText={"ManualRegistered"}
                    inputName={"ManualRegistered"}
                    type="checkbox"
                    mode={mode}
                  />
                </div>
              </div>
              <>
                {mode != "view" ? (
                  <div className="col-lg-12 mt-1 btns_form">
                    <Button value="save" btnType="submit" />
                    <Button
                      btnType="cancel"
                      value="Cancel"
                      onClick={() => {
                        onHide();
                      }}
                    />
                  </div>
                ) : (
                  <div className="col-lg-12 mt-1 btns_form">
                    <Button
                      btnType="primary"
                      value="close"
                      onClick={() => onHide()}
                    />
                  </div>
                )}
              </>
            </form>
          </div>
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
};
